import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const FormListService = {
  getAll,
  getAllList,
  getAllForms,
  getAllFormLists,
  addFormList,
  updateFormList,
  deleteFormList,
};

async function getAll() {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/form-lists/getAll`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllList(node_id) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/form-lists/getAll/${node_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllForms(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/manage/form-lists/getAllFormLists/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllFormLists() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/form-lists/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addFormList(newFormList) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newFormList),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/form-lists/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateFormList(formListItem, formListId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(formListItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/form-lists/update/${formListId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteFormList(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/form-lists/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}